import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { CreateExperimentForm, ExperimentListSection } from 'src/components-bl';
import { Page, Typography, TypographyType, TypographyVariant } from 'src/components-dummy';
import './ExperimentsContainer.scss';
import { experimentRoutes, RoutedComponentProps } from 'src/app-routes';

type ExperimentsContainerProps = RoutedComponentProps;

const ConnectedExperimentsListSection = ({
  permittedRouteMap,
}: ExperimentsContainerProps): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { experiments, selectedExperimentId, runningExperiment } = useAppSelector(
    state => state.experiments
  );
  const shopId = useAppSelector(state => state.shop.current?.shopId);

  const experimentFormRoute = permittedRouteMap.experimentWizard?.path;

  const onViewResults = (experimentId: string): void => {
    if (!shopId) return;
    history.push(generatePath(experimentRoutes.abTestDashboard.path, { shopId, experimentId }));
  };

  return shopId ? (
    <ExperimentListSection
      experiments={experiments}
      dispatch={dispatch}
      shopId={shopId}
      experimentFormRoute={experimentFormRoute}
      selectedExperimentId={selectedExperimentId}
      runningExperimentId={runningExperiment?.id}
      onViewResults={onViewResults}
    />
  ) : null;
};

const ConnectedCreateExperimentForm = ({
  permittedRouteMap,
}: ExperimentsContainerProps): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const shopId = useAppSelector(state => state.shop.current?.shopId);

  const editExperimentFormRoute = permittedRouteMap.experimentWizard?.path;

  return shopId ? (
    <CreateExperimentForm
      shopId={shopId}
      dispatch={dispatch}
      editExperimentFormRoute={editExperimentFormRoute}
    />
  ) : null;
};

export const ExperimentsContainer = ({
  permittedRouteMap,
}: ExperimentsContainerProps): JSX.Element => {
  return (
    <div className='syte-experiments-container'>
      <Page>
        <Page.Header className='syte-experiments-container-header'>
          <Page.Title>
            <Typography
              className='syte-experiments-container-title'
              type={TypographyType.Heading}
              variant={TypographyVariant.ExtraSmallBold}
            >
              Experiments
            </Typography>
          </Page.Title>
          <div className='syte-experiments-container-header-buttons'>
            <ConnectedCreateExperimentForm permittedRouteMap={permittedRouteMap} />
          </div>
        </Page.Header>
        <Page.Content>
          <ConnectedExperimentsListSection permittedRouteMap={permittedRouteMap} />
        </Page.Content>
      </Page>
    </div>
  );
};
